import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/img/loading.gif'


const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Carga de Documentos")
], -1)
const _hoisted_4 = { class: "form" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "txtempresa",
  class: "form-label"
}, "Empresa", -1)
const _hoisted_7 = {
  key: 0,
  class: "alert alert-success"
}
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = {
  key: 0,
  src: _imports_0,
  width: "32",
  height: "32"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Subir")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListUpload = _resolveComponent("ListUpload")!
  const _component_Strong = _resolveComponent("Strong")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("form", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.objSubm.enterprise) = $event)),
            class: "form-control",
            id: "txtempresa",
            placeholder: "Obligatorio"
          }, null, 512), [
            [_vModelText, _ctx.objSubm.enterprise]
          ])
        ])
      ]),
      _createVNode(_component_ListUpload)
    ]),
    (_ctx.mostrarAlerta)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.loaded_files.length) + " Archivos cargados ", 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        class: "btn btn-success",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.upFiles && _ctx.upFiles(...args)))
      }, [
        _createElementVNode("span", null, [
          (_ctx.mostrarGif)
            ? (_openBlock(), _createElementBlock("img", _hoisted_9))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Strong, null, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        })
      ])
    ])
  ]))
}